var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSecurityAccessHigh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 94,
    viewBox: "0 0 108 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.7189 56.5007L79.8744 60.7605L79.2022 54.7357L90.7189 56.5007Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7660_16514",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 108,
    height: 78
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 83.5V6.5H107.5V83.5H0.5Z",
    fill: "#E8EBEF",
    stroke: "#3C9103"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7660_16514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.186 102.372C78.5893 102.372 98.372 82.5893 98.372 58.186C98.372 33.7827 78.5893 14 54.186 14C29.7827 14 10 33.7827 10 58.186C10 82.5893 29.7827 102.372 54.186 102.372Z",
    stroke: "#E8EBEF",
    strokeWidth: 6.16549,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.03 10.28"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7660_16514",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 103,
    height: 78
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103 6H0V84H36.5L103 52V6Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7660_16514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.372 58.186C98.372 82.5893 78.5893 102.372 54.186 102.372C29.7828 102.372 10 82.5893 10 58.186C10 33.7828 29.7828 14 54.186 14C78.5893 14 98.372 33.7828 98.372 58.186Z",
    stroke: "#3C9103",
    strokeWidth: 6.16549,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.03 10.28"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8479 58.5001C79.8479 44.5009 68.4993 33.1523 54.5001 33.1523C40.5009 33.1523 29.1523 44.5009 29.1523 58.5001C29.1523 72.4993 40.5009 83.8479 54.5001 83.8479C68.4993 83.8479 79.8479 72.4993 79.8479 58.5001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.375 56.5H50.375C49.8777 56.5 49.4008 56.3025 49.0492 55.9508C48.6976 55.5992 48.5 55.1223 48.5 54.625C48.5 54.1277 48.6976 53.6508 49.0492 53.2992C49.4008 52.9475 49.8777 52.75 50.375 52.75H63.375C63.5408 52.75 63.6998 52.8158 63.817 52.9331C63.9342 53.0503 64 53.2092 64 53.375V55.875C64 56.0408 63.9342 56.1997 63.817 56.3169C63.6998 56.4342 63.5408 56.5 63.375 56.5Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.375 51.5H54.75V50.25C54.75 49.9185 54.6183 49.6005 54.3839 49.3661C54.1495 49.1317 53.8315 49 53.5 49H47.25C46.9185 49 46.6006 49.1317 46.3661 49.3661C46.1317 49.6005 46 49.9185 46 50.25V67.75C46 68.0815 46.1317 68.3995 46.3661 68.6339C46.6006 68.8683 46.9185 69 47.25 69H53.5C53.8315 69 54.1495 68.8683 54.3839 68.6339C54.6183 68.3995 54.75 68.0815 54.75 67.75V57.75H50.375C49.5462 57.75 48.7514 57.4208 48.1653 56.8347C47.5793 56.2487 47.25 55.4538 47.25 54.625C47.25 53.7962 47.5793 53.0013 48.1653 52.4153C48.7514 51.8292 49.5462 51.5 50.375 51.5ZM50.375 61.5C50.7334 61.5007 51.0806 61.6247 51.3585 61.851C51.6364 62.0773 51.828 62.3923 51.9013 62.7431C51.9745 63.0939 51.925 63.4593 51.7609 63.7779C51.5968 64.0965 51.3282 64.349 51 64.4931V65.875C51 66.0408 50.9342 66.1997 50.817 66.3169C50.6998 66.4342 50.5408 66.5 50.375 66.5C50.2093 66.5 50.0503 66.4342 49.9331 66.3169C49.8159 66.1997 49.75 66.0408 49.75 65.875V64.4931C49.4219 64.349 49.1533 64.0965 48.9892 63.7779C48.8251 63.4593 48.7755 63.0939 48.8488 62.7431C48.922 62.3923 49.1137 62.0773 49.3915 61.851C49.6694 61.6247 50.0166 61.5007 50.375 61.5Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8479 58.3478C79.8479 44.3486 68.4993 33 54.5001 33C40.5009 33 29.1523 44.3486 29.1523 58.3478C29.1523 72.347 40.5009 83.6956 54.5001 83.6956C68.4993 83.6956 79.8479 72.347 79.8479 58.3478Z",
    stroke: "#333333",
    strokeWidth: 2.30435
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurityAccessHigh);
export default __webpack_public_path__ + "static/media/icon-security-access-high.78b0aaf9456a028658d8826ba3fc16bb.svg";
export { ForwardRef as ReactComponent };